import { createContext } from 'react'

/**
 * Slots for the deep-analysis page redesign. When provided, the indicator
 * data layer (QuestionData) portals its detail content into page-level
 * sections instead of rendering the info popover / inline-details block:
 *
 *  - factsEl: the facts pane of the context card ("Over dit effect") —
 *    receives the Onderzoek / Meetmoment / Vragenlijst / Antwoorden rows.
 *  - participationEl: the "Deelname" section body — receives the
 *    answers-per-week chart, the totals column and (portfolio tenants)
 *    the per-project breakdown.
 *  - detailsEl: the facts pane of the context card on the research and
 *    activity pages — CardHeaderInfoPopover portals each visualisation's
 *    "Details" content into it, so it stands in its own card above the
 *    results instead of inside the result card.
 *
 * Default null: outside a deep-analysis layout nothing changes.
 *
 *  - B: a second set of the same slots for the compare period; ParentCompareView
 *    hands each side its own set via helpers/deepAnalysis/slotsForSide.
 * @type {React.Context<{factsEl: HTMLElement|null, participationEl: HTMLElement|null, detailsEl?: HTMLElement|null, B?: {factsEl: HTMLElement|null, participationEl: HTMLElement|null, detailsEl?: HTMLElement|null}|null}|null>}
 */
const DeepAnalysisSlotsContext = createContext(null)

export default DeepAnalysisSlotsContext
